
<div class="row border rounded p-2 mb-2 ms-1 me-1">
    <form role="form">
        <div class="row row-cols-lg-auto g-2 align-items-center">
            <label class="col-form-label-sm">Loc:</label>
            <div class="col-12">
                <select name="locCode" class="form-select form-select-sm select-m" (change)="locCodeChange()" [(ngModel)]="scheduleParms.locCode">
                    <option *ngFor="let item of locList" value="{{item.value}}">{{item.text}}</option>
                </select>
            </div>
            <label class="col-form-label-sm">Plan By:</label>
            <div class="col-12">
                <select name="locationType" class="form-select form-select-sm" [(ngModel)]="scheduleParms.locationType">
                    <option [ngValue]="0">Origin</option>
                    <option [ngValue]="1">Destination</option>
                </select>
            </div>
            <label class="col-form-label-sm">Plan Period:</label>
            <div class="col-12">
                <select name="planPeriod" class="form-select form-select-sm" (change)="planPeriodChange()" [(ngModel)]="scheduleParms.planPeriod">
                    <option *ngFor="let item of planPeriods; trackBy: trackPlanPeriod" [value]="item.value">{{item.text}}</option>
                </select>
            </div>
            <div class="col-12">
                <input type="date" name="planStartDate" class="form-control form-control-sm date-input" 
                disabled [(ngModel)]="scheduleParms.periodStartDate" [ngModelOptions]="{standalone: true}" [attr.disabled]="scheduleParms.planPeriod === 'Custom' ? null: ''"/>
            </div>
            <div class="col-12">
                -
            </div>
            <div class="col-12">
                <input type="date" name="planEndDate" class="form-control form-control-sm date-input" disabled [(ngModel)]="scheduleParms.periodEndDate" [attr.disabled]="scheduleParms.planPeriod === 'Custom' ? null : ''" />
            </div>
            <label class="col-form-label-sm">Begin Ship Date Through:</label>
            <div class="col-12">
                <input type="date" name="planThroughDate" class="form-control form-control-sm date-input" [(ngModel)]="scheduleParms.shipThroughDate" />
            </div>
            <div class="col-12">
                <button type="button" class="btn btn-sm btn-primary" (click)="refreshScheduleData(false)" *ngIf="!refreshingData()">Refresh</button>
                <button type="button" class="btn btn-sm btn-primary me-2" disabled *ngIf="refreshingData()">
                    <span class="spinner-border spinner-border-sm me-1"></span>
                    <span>Loading...</span>
                </button>
            </div>
            <div class="col-12 text-danger" *ngIf="invalidDateRange">
                Invalid date range entered
            </div>
        </div>
    </form>
</div>

<div class="ms-1 me-1">
    <ul class="nav nav-underline" id="tabs" role="tablist">
        <li class="nav-item" role="presentation">
            <button class="nav-link" id="staging-tab" data-bs-toggle="tab" data-bs-target="#staging-tab-pane" type="button" role="tab"
                    aria-controls="staging-tab-pane" aria-selected="true"
                    (click)="tabClick('staging')">
                Demand Staging
            </button>
        </li>
        <li class="nav-item" role="presentation">
            <button class="nav-link active" id="schedules-tab" data-bs-toggle="tab" data-bs-target="#schedules-tab-pane" type="button" role="tab"
                    aria-controls="schedules-tab-pane" aria-selected="false"
                    (click)="tabClick('schedule')">
                Schedules
            </button>
        </li>
        <!--<li class="nav-item" role="presentation">
            <button class="nav-link" id="daily-loads-tab" data-bs-toggle="tab" data-bs-target="#daily-loads-tab-pane" type="button" role="tab"
                    aria-controls="daily-loads-tab-pane" aria-selected="false">
                Daily Loads
            </button>
        </li>-->
        <li class="nav-item" role="presentation">
            <button class="nav-link" id="trucker-summary-tab" data-bs-toggle="tab" data-bs-target="#trucker-summary-tab-pane" type="button" role="tab"
                    aria-controls="tucker-summary-tab-pane" aria-selected="false"
                    (click)="tabClick('truckerSummary')">
                Trucker Summary
            </button>
        </li>
    </ul>
</div>

<div class="tab-content" id="tabContent">
    <div class="tab-pane fade" id="staging-tab-pane" role="tabpanel" aria-labelledby="staging-tab" tabindex="0">
        <staging [scheduleParameters]="refreshParameters" [refreshGrid]="refreshStagingGrid" (refreshDataComplete)="stagingRefreshComplete($event)" (schedulesChanged)="schedulesChanged($event)"></staging>
    </div>
    <div class="tab-pane fade show active" id="schedules-tab-pane" role="tabpanel" aria-labelledby="schedules-tab" tabindex="0">
        <schedules [planningParameters]="refreshParameters" [refreshGrid]="refreshSchedulesGrid" [refreshData]="refreshSchedulesData" (refreshDataComplete)="schedulesRefreshComplete($event)" ></schedules>
    </div>
    <!--<div class="tab-pane fade" id="daily-loads-tab-pane" role="tabpanel" aria-labelledby="daily-loads-tab" tabindex="0">

    </div>-->
    <div class="tab-pane fade" id="trucker-summary-tab-pane" role="tabpanel" aria-labelledby="trucker-summary-tab" tabindex="0">
        <trucker-summary #truckerSummary [scheduleParameters]="refreshParameters"></trucker-summary>
    </div>
</div>
